@if (sliderOptions().length > 0) {
  <ion-range
    [ngClass]="disabled() ? 'disabled' : ''"
    [disabled]="disabled()"
    [min]="sliderOptions()[0].value"
    [max]="sliderOptions()[sliderOptions().length - 1].value"
    step="1"
    snaps="true"
    [value]="value()"
    (ionChange)="onValueChange($event.detail.value)"
    [style.padding-left.%]="lateralPaddings()"
    [style.padding-right.%]="lateralPaddings()"
  ></ion-range>
}

<div>
  <div
    class="libelle"
    *ngFor="let option of sliderOptions()"
    [class.selected]="option.value === value()"
    (click)="clickTextSlider(option.value)"
  >
    {{ option.libelle }}
  </div>
</div>
